export default "__VITE_ASSET__Dw0rv54z__"